/**
 * Resolve a lead's cost across every schema location. `cost` defaults to 0 on
 * the model, so the first positive value wins (a plain `??` chain would stop at 0).
 * @param {object} lead
 * @returns {number|null} Cost in dollars, or null when none is set.
 */
export function resolveLeadCost(lead) {
  if (!lead) return null;
  const candidates = [lead.cost, lead.acquisitionCost, lead.costForLead, lead.attribution?.acquisitionCost];
  for (const c of candidates) {
    const n = Number(c);
    if (c !== undefined && c !== null && c !== '' && Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

/**
 * @param {object} lead
 * @returns {string} e.g. "$20.00", or '' when no cost is set.
 */
export function formatLeadCost(lead) {
  const n = resolveLeadCost(lead);
  return n === null ? '' : `$${n.toFixed(2)}`;
}
